import React, { RefObject, useMemo, useState } from 'react';

import dayjs from 'dayjs';
import Cropper from 'react-easy-crop';
import { Area, Point } from 'react-easy-crop';

import { ReturnComponentType } from 'common';
import { CommonModal } from 'components/Modals/CommonModal';
import './ModalShowScreen.scss';
import { DateFormat } from 'enums';
/* import {
  ViolationCategories,
  AnimalsSubcategories,
  DecorationsSubcategories,
  FencingSubcategories,
  ImproperSubcategories,
  PhotoSubcategories,
  LandscapingSubcategories,
  MaintenanceSubcategories,
  NoiseSubcategories,
  RubbishSubcategories,
  SignsSubcategories,
  SportSubcategories,
  UnapprovedSubcategories,
  UnsightlySubcategories,
  VehicleSubcategories,
} from 'enums/ViolationCategories'; */
import { useAppSelector, useTypedDispatch } from 'hooks';
import { createScreen, FileType, selectLoading, selectTimeCodes } from 'state';
import { Button } from 'ui-kit';
// import { ISelectOption } from 'ui-kit/Select/Select';
import { checkIsGoodStatus, convertTimeToNumber, getCroppedImage } from 'utils';

type ModalShowScreenType = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  image?: string;
  videoRef?: RefObject<HTMLVideoElement>;
  selectedFile?: FileType;
};
export const ModalShowScreen = ({
  showModal,
  setShowModal,
  image,
  videoRef,
  selectedFile,
}: ModalShowScreenType): ReturnComponentType => {
  const dispatch = useTypedDispatch();
  const timeCodes = useAppSelector(selectTimeCodes);
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);
  // const [selectedCategory, setSelectedCategory] = useState('');
  // const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const isLoading = useAppSelector(selectLoading);
  const closeShowScreenModal = () => {
    setShowModal(false);
  };

  const propertyId = useMemo(() => {
    return (
      // eslint-disable-next-line array-callback-return
      timeCodes.find(timeCode => {
        if (videoRef?.current?.currentTime) {
          return (
            convertTimeToNumber(timeCode.timecodeStart) <=
              videoRef?.current?.currentTime &&
            convertTimeToNumber(timeCode.timecodeEnd) >= videoRef?.current?.currentTime
          );
        }
      })?.propertyId ?? 'no-property'
    );
  }, [timeCodes, videoRef]);

  /* const categoriesOptions: ISelectOption[] = Object.values(ViolationCategories).map(
    (item, i) => {
      return { value: `${i}`, label: item };
    },
  ); */

  /* const subCategoriesOptions: ISelectOption[] = useMemo(() => {
    const selected = selectedCategory.split(' ')[0];

    if (selected === 'Animals') {
      return Object.values(AnimalsSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Decorations') {
      return Object.values(DecorationsSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Fencing') {
      return Object.values(FencingSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Improper') {
      return Object.values(ImproperSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Photo') {
      return Object.values(PhotoSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Landscaping') {
      return Object.values(LandscapingSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Maintenance') {
      return Object.values(MaintenanceSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Noise') {
      return Object.values(NoiseSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Rubbish') {
      return Object.values(RubbishSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Signs') {
      return Object.values(SignsSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Sport') {
      return Object.values(SportSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Unapproved') {
      return Object.values(UnapprovedSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Unsightly') {
      return Object.values(UnsightlySubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }
    if (selected === 'Vehicle') {
      return Object.values(VehicleSubcategories).map((item, i) => {
        return { value: `${i}`, label: item };
      });
    }

    return [];
  }, [selectedCategory]);
   const onChangeCategory = (e: any) => {
    setSelectedCategory(e.label);
  };
  const onChangeSubcategory = (e: any) => {
    setSelectedSubcategory(e.label);
  }; */
  const createFileName = (...names: string[]) => {
    return `${names.join('')}.jpg`;
  };

  const download = async () => {
    const a = document.createElement('a');
    const date = new Date();
    const name = createFileName(
      `${image ? propertyId : selectedFile?.fileName.slice(0, -4)}-${dayjs(date).format(
        DateFormat.IMAGE,
      )}`,
    );

    if (!image || !croppedAreaPixels) return;

    const croppedImage = await getCroppedImage(image, croppedAreaPixels);

    // @ts-ignore
    a.href = croppedImage;
    a.download = name;
    a.click();
    a.remove();
    // @ts-ignore
    const file = new File([croppedImage], name, { type: 'image/jpg' });

    const response = await dispatch(
      createScreen({
        file,
        /* category: selectedCategory,
        subcategory: selectedSubcategory, */
      }),
    );

    if (checkIsGoodStatus(response?.status)) {
      closeShowScreenModal();
    }
  };

  const onCropComplete = (area: any, pixels: any) => {
    setCroppedAreaPixels(pixels);
  };

  return (
    <CommonModal showModal={showModal} closeModal={closeShowScreenModal} escToClose>
      <div className="ModalShowScreen">
        <header className="ModalShowScreen_Header">
          <h4 className="ModalShowScreen_Header_Title">Screenshot</h4>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div onClick={closeShowScreenModal} className="ModalShowScreen_Header_Close">
            &#10006;
          </div>
        </header>
        <div className="ModalShowScreen_Content">
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={3 / 2}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
        {/* <span>Category</span>
        <Select
          placeholder="Select category"
          options={categoriesOptions}
          className="ModalShowScreen_Select"
          onChange={e => onChangeCategory(e)}
        />
        <span>Subcategory</span>
        <Select
          placeholder="Select subcategory"
          options={subCategoriesOptions}
          className="ModalShowScreen_Select"
          onChange={e => onChangeSubcategory(e)}
          menuPlacement="auto"
        /> */}
        <Button
          autoFocus
          onClick={download}
          className="ModalShowScreen_Save"
          disabled={/*! selectedCategory || !selectedSubcategory || */ isLoading}
        >
          Save
        </Button>
      </div>
    </CommonModal>
  );
};
